import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './auth.service';
import { ToastService } from './toast.service';
import { ALLOW_DEVTOOLS } from '../../config';

@Injectable({
  providedIn: 'root'
})
export class DevToolsDetectionService {
  private threshold = 160;
  private isDevToolsOpen = false;
  private lastCheckTime = 0;
  private initialDevicePixelRatio = window.devicePixelRatio;
  private renderer!: Renderer2;
  private intervalId: any;
  public isDevToolsCurrentlyOpen = false;

  constructor(
    private router: Router,
    rendererFactory: RendererFactory2,
    private authService: AuthService,
    private toastService: ToastService
  ) {
    this.renderer = rendererFactory.createRenderer(null, null);
    this.startDetection();
  }

  private checkDevToolsStatus() {
    const now = performance.now();
    if (now - this.lastCheckTime > 1000) {
      this.lastCheckTime = now;

      // Skip detection in development mode
      if (ALLOW_DEVTOOLS) {
        return;
      }

      // Detect zoom change (optional)
      const zoomed = Math.abs(window.devicePixelRatio - this.initialDevicePixelRatio) > 0.1;
      if (zoomed) {
        this.handleDevToolsOpen();
        return;
      }

      // Detect devtools based on window size difference
      const devToolsOpen = window.outerWidth - window.innerWidth > this.threshold ||
        window.outerHeight - window.innerHeight > this.threshold;

      if (devToolsOpen && !this.isDevToolsOpen) {
        this.isDevToolsOpen = true;
        this.isDevToolsCurrentlyOpen = true;
        this.handleDevToolsOpen();
      } else if (!devToolsOpen && this.isDevToolsOpen) {
        this.isDevToolsOpen = false;
        this.isDevToolsCurrentlyOpen = false;
        this.handleDevToolsClose();
      }
    }
  }


  startDetection() {
    this.checkDevToolsStatus();  // Immediate check
    this.intervalId = setInterval(() => {
      this.checkDevToolsStatus();
    }, 100);
  }

  handleDevToolsOpen() {
    if (ALLOW_DEVTOOLS) {
      return;
    }
    clearInterval(this.intervalId);
    sessionStorage.setItem('devToolsDetected', 'true');
    this.authService.signOut();
    this.router.navigate(['/auth/devtools-detected']);
  }

  handleDevToolsClose() {
    if (ALLOW_DEVTOOLS) {
      return;
    }
    this.router.navigate(['/']);
  }
}